import { useEffect, useRef } from 'react';

const CSS_VAR = '--header-height';

export const useHeaderHeight = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const setHeight = () => {
      document.documentElement.style.setProperty(CSS_VAR, `${el.offsetHeight}px`);
    };

    setHeight();

    const observer = new ResizeObserver(setHeight);
    observer.observe(el);

    return () => {
      observer.disconnect();
      document.documentElement.style.removeProperty(CSS_VAR);
    };
  }, []);

  return ref;
};
